import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { STATUS_META, type EventInboxStatus } from '../eventInboxTypes';

interface EventInboxStatusBadgeProps {
  status: EventInboxStatus;
  size?: 'small' | 'medium';
}

/**
 * Status pill for an Event Inbox entry. Maps the domain status to a MUI
 * semantic Chip colour (PENDING→info, PROCESSING→warning, DONE→success,
 * FAILED→error) and always carries an explicit `aria-label` so screen readers
 * announce the status by name rather than relying on colour alone.
 */
export function EventInboxStatusBadge({ status, size = 'small' }: EventInboxStatusBadgeProps) {
  const { t } = useTranslation('eventInbox');
  const meta = STATUS_META[status];
  const label = t(meta.labelKey);

  return (
    <Chip
      label={label}
      color={meta.color}
      size={size}
      variant="filled"
      aria-label={t('statusBadge.aria', { status: label })}
      sx={{ fontWeight: 600, letterSpacing: '0.02em' }}
    />
  );
}
